export const zendeskHistory = {
	page: {
		title: "Meus chamados",
		subtitle: "Acompanhe o status e as respostas dos chamados que você abriu.",
	},
	filters: {
		placePlaceholder: "Filtrar por local",
		statusPlaceholder: "Filtrar por status",
		searchPlaceholder: "Buscar por assunto ou ID",
	},
	table: {
		columns: {
			createdAt: "Criado em",
			id: "ID",
			subject: "Assunto",
			placeName: "Local",
			updatedAt: "Última atualização",
			status: "Status",
		},
		viewDetails: "Ver detalhes",
	},
	pagination: {
		pageSizeLabel: "Resultados por página",
	},
	emptyState: {
		noData: {
			title: "Nenhum chamado encontrado",
			description:
				"Você ainda não abriu nenhum chamado. Quando precisar de suporte, abra um chamado para acompanhar aqui.",
		},
		noFilters: {
			title: "Nenhum chamado para os filtros aplicados",
			description:
				"Tente ajustar a busca, o local, o status ou o período para encontrar o que procura.",
		},
	},
	status: {
		open: "Aberto",
		ongoing: "Em andamento",
		closed: "Resolvido",
	},
	detail: {
		title: "Detalhes do chamado",
		loading: "Carregando detalhes do chamado...",
		createdAt: "Criado em {{date}}",
		closedAt: "Chamado encerrado em {{date}}",
		downloadAttachment: "Baixar anexo",
		requesterLabel: "Você",
	},
};
